(function () {
  'use strict';

  function initMediatorProductPage(root) {
    if (!root || root.getAttribute('data-hnx-initialized') === 'true') return;
    root.setAttribute('data-hnx-initialized', 'true');

    var menuToggle = root.querySelector('[data-hnx-menu-toggle]');
    var mobileNav = root.querySelector('[data-hnx-mobile-nav]');

    function closeMenu() {
      if (!menuToggle || !mobileNav) return;
      mobileNav.classList.remove('is-open');
      menuToggle.setAttribute('aria-expanded', 'false');
    }

    if (menuToggle && mobileNav) {
      menuToggle.addEventListener('click', function () {
        var open = mobileNav.classList.toggle('is-open');
        menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });

      mobileNav.addEventListener('click', function (event) {
        if (event.target.closest('a')) closeMenu();
      });
    }

    var gallery = root.querySelector('[data-hnx-gallery]');
    if (gallery) {
      // 2026-10-22: swipe/scroll-snap gallery. The track scrolls natively (touch swipe, trackpad,
      // keyboard); thumbnails and arrows scroll it, and scrolling updates the active thumbnail.
      var track = gallery.querySelector('[data-hnx-gallery-track]');
      var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-hnx-gallery-slide]'));
      var thumbnails = Array.prototype.slice.call(gallery.querySelectorAll('[data-hnx-gallery-thumb]'));
      var thumbStrip = gallery.querySelector('[data-hnx-gallery-thumbs]');
      var counter = gallery.querySelector('[data-hnx-gallery-current]');
      var activeIndex = 0;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function markActive(index) {
        if (index === activeIndex && gallery.getAttribute('data-active-index') === String(index)) return;
        activeIndex = index;
        gallery.setAttribute('data-active-index', String(index));
        if (counter) counter.textContent = String(index + 1);
        thumbnails.forEach(function (thumbnail) {
          var selected = parseInt(thumbnail.getAttribute('data-hnx-gallery-thumb'), 10) === index;
          thumbnail.classList.toggle('is-active', selected);
          thumbnail.setAttribute('aria-current', selected ? 'true' : 'false');
          if (selected && thumbStrip) {
            var left = thumbnail.offsetLeft - (thumbStrip.clientWidth - thumbnail.offsetWidth) / 2;
            thumbStrip.scrollTo({ left: Math.max(0, left), behavior: reduceMotion ? 'auto' : 'smooth' });
          }
        });
      }

      function goTo(index) {
        if (!track || !slides.length) return;
        var target = (index + slides.length) % slides.length;
        track.scrollTo({ left: target * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
        markActive(target);
      }

      if (track && slides.length) {
        var ticking = false;
        track.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(function () {
            ticking = false;
            var width = track.clientWidth || 1;
            var index = Math.round(track.scrollLeft / width);
            markActive(Math.min(slides.length - 1, Math.max(0, index)));
          });
        }, { passive: true });

        track.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowRight') { event.preventDefault(); goTo(activeIndex + 1); }
          if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(activeIndex - 1); }
        });
      }

      thumbnails.forEach(function (thumbnail) {
        thumbnail.addEventListener('click', function () {
          goTo(parseInt(thumbnail.getAttribute('data-hnx-gallery-thumb'), 10));
        });
      });

      gallery.querySelectorAll('[data-hnx-gallery-move]').forEach(function (button) {
        button.addEventListener('click', function () {
          goTo(activeIndex + parseInt(button.getAttribute('data-hnx-gallery-move'), 10));
        });
      });
    }

    var pillars = root.querySelector('[data-hnx-pillars]');
    if (pillars) {
      var tabs = Array.prototype.slice.call(pillars.querySelectorAll('[data-hnx-pillar-tab]'));
      var panels = Array.prototype.slice.call(pillars.querySelectorAll('[data-hnx-pillar-panel]'));

      function activatePillar(tab, focusTab) {
        var selected = tab.getAttribute('data-hnx-pillar-tab');
        tabs.forEach(function (candidate) {
          var active = candidate.getAttribute('data-hnx-pillar-tab') === selected;
          candidate.classList.toggle('is-active', active);
          candidate.setAttribute('aria-selected', active ? 'true' : 'false');
          candidate.setAttribute('tabindex', active ? '0' : '-1');
        });
        panels.forEach(function (panel) {
          panel.hidden = panel.getAttribute('data-hnx-pillar-panel') !== selected;
        });
        if (focusTab) tab.focus();
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          activatePillar(tab, false);
        });

        tab.addEventListener('keydown', function (event) {
          var nextIndex = null;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          if (nextIndex === null) return;
          event.preventDefault();
          activatePillar(tabs[nextIndex], true);
        });
      });
    }

    root.querySelectorAll('[data-hnx-faq-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        var answerId = toggle.getAttribute('aria-controls');
        var answer = answerId ? root.querySelector('#' + answerId) : null;
        var symbol = toggle.querySelector('[data-hnx-faq-symbol]');
        toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (answer) answer.hidden = expanded;
        if (symbol) symbol.textContent = expanded ? '+' : '−';
      });
    });

    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeMenu();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-hnx-mediator-product-page]').forEach(initMediatorProductPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
